export default __webpack_public_path__ + "static/media/me3_Heart_Filled_Icon.5181d07c.svg";